const Close = ({ width = 20, height = 20, color = 'currentColor', ...props }) => {
  return (
    <svg
      aria-hidden="true"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      color={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.4997 10.5862L17.4497 5.63623L18.8637 7.05023L13.9137 12.0002L18.8637 16.9502L17.4497 18.3642L12.4997 13.4142L7.54974 18.3642L6.13574 16.9502L11.0857 12.0002L6.13574 7.05023L7.54974 5.63623L12.4997 10.5862Z"
        fill={color}
      />
    </svg>
  )
}

export default Close
